import React, { FC, useState } from 'react'
import moment from 'moment'
import { LightningBoltIcon } from '@heroicons/react/solid'
import useDraft from '../../../redux/draft-drawer/useDraft'
import { StyledDraftDrawerScheduleBanner } from '.'
import { useDraftActions } from '../../DraftsView'
import { ActionDialog } from '../../System'

const DraftDrawerScheduleBanner: FC = () => {
  const {
    postDate,
    socialProfiles,
    actions: { clearDraftDate, setDraftSocialProfiles, setShowShareModal }
  } = useDraft()
  const { handleSaveDraft } = useDraftActions()
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)

  const clearScheduledDraft = async () => {
    setDraftSocialProfiles([])
    clearDraftDate()
    await handleSaveDraft(false, {
      draftObject: {
        postDate: null,
        socialProfiles: []
      },
      merge: true
    })
  }

  if (!postDate) {
    return <></>
  }

  return (
    <>
      <StyledDraftDrawerScheduleBanner>
        <div className="banner-header">
          <div className="banner-header-icon">
            <LightningBoltIcon />
          </div>
          <span>
            {socialProfiles?.length ? 'Auto-posting on' : 'Scheduled for'}{' '}
            {moment(postDate).format('MMMM D [at] h:mmA')}
          </span>
        </div>
        <div className="banner-actions">
          <button onClick={() => setShowConfirmationModal(true)}>Cancel</button>
          <button className="reschedule-btn" onClick={() => setShowShareModal(true, true)}>
            Re-Schedule
          </button>
        </div>
      </StyledDraftDrawerScheduleBanner>
      <ActionDialog
        type="error"
        isOpen={showConfirmationModal}
        title="Are You Sure?"
        body={`Cancelling will stop this post from publishing on ${moment(postDate).format(
          'MMMM D [at] h:mmA'
        )}.`}
        cancelButtonText="Return"
        confirmButtonText="Cancel Scheduled Post"
        onClose={() => setShowConfirmationModal(false)}
        onConfirm={() => clearScheduledDraft()}
      />
    </>
  )
}

export default DraftDrawerScheduleBanner
